export const colors = {
    primary: '#7950ff',
    custom: '#0e0e0e',
    secondary: '#dc004e',
    background: '#f5f5f5',
    surface: '#ffffff',
    textPrimary: '#000000',
    textSecondary: '#555555',
    border: '#e0e0e0',
    error: '#d32f2f',
    warning: '#f15a61',
    warningHover: '#d14950',
    info: '#0288d1',
    success: '#388e3c',
    divider: '#bdbdbd',
    nonActive: "#6d758e",
    grayLight: '#858c9a',
    grayBackground: '#ced1d9',
    white: '#fff',
    disabled: '#f5f5f7',
    toggle: '#edeef1',
    logoDisabled: '#ece6ff',
    chipsBg: '#eaf1fb',
    storkeLight: '#e6e6e6',
    uiGrey: '#838993',
    hoverBackground: '#f9f9f9',
    
    // Status colors for Smart Plans
    statusSuccess: '#0E867C',
    statusPending: '#CE7E16',
    statusCancelled: '#858C9A',
    
    // Opacity values
    disabledOpacity: 0.5,
};